import { render, staticRenderFns } from "./delinkAccountComponent.vue?vue&type=template&id=2bfb97b7&"
import script from "./delinkAccountComponent.vue?vue&type=script&lang=js&"
export * from "./delinkAccountComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports